import IMask from 'imask';
import { ChangeEvent } from 'react';

interface Mask {
  masked: any;
  transform?: any;
  maskDefault?: any;
}

const masker = ({ masked, transform, maskDefault }: Mask) =>
  (function () {
    const mask = IMask.createPipe(
      masked,
      IMask.PIPE_TYPE.UNMASKED,
      IMask.PIPE_TYPE.MASKED
    );

    const unmask = IMask.createPipe(
      masked,
      IMask.PIPE_TYPE.MASKED,
      IMask.PIPE_TYPE.UNMASKED
    );

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
      const unmasked = unmask(e.target.value);
      const newValue = mask(unmasked);
      e.target.value = newValue;
    };

    return {
      mask,
      onChange,
      transform: transform || unmask,
      unmask,
      maskDefault: maskDefault || mask,
    };
  })();

export const cpfMask = masker({
  masked: {
    mask: [
      {
        mask: '000.000.000-00',
        type: 'CPF',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const cpfMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'CPF'
      );

      return cpfMask;
    },
  },
});

export const cnpjMask = masker({
  masked: {
    mask: [
      {
        mask: '00.000.000/0000-00',
        type: 'CNPJ',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const cnpjMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'CNPJ'
      );

      return cnpjMask;
    },
  },
});

export const rgMask = masker({
  masked: {
    mask: [
      {
        mask: '00.000.000-0',
        type: 'RG',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const rgMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'RG'
      );

      return rgMask;
    },
  },
});

export const expirationMask = masker({
  masked: {
    mask: [
      {
        mask: '00/0000',
        type: 'Expiration',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const expirationMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'Expiration'
      );

      return expirationMask;
    },
  },
});

export const cepMask = masker({
  masked: {
    mask: [
      {
        mask: '00000-000',
        type: 'CEP',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const cepMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'CEP'
      );

      return cepMask;
    },
  },
});

export const phoneMask = masker({
  masked: {
    mask: [
      {
        mask: '(00) 0000-0000',
        phone: 'landline',
      },
      {
        mask: '(00) 00000-0000',
        phone: 'mobile',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const landlineMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.phone === 'landline'
      );

      const mobileMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.phone === 'mobile'
      );

      if (
        `${dynamicMasked.value}${appended}`.length > landlineMask.mask.length
      ) {
        return mobileMask;
      }

      return landlineMask;
    },
  },
});

export const currencyMask = masker({
  masked: {
    mask: 'R$ num{,}cents',
    blocks: {
      num: {
        mask: Number,
        signed: true,
        thousandsSeparator: '.',
        mapToRadix: [''],
        scale: 0,
      },
      cents: {
        mask: '00',
        normalizeZeros: true,
        padFractionalZeros: true,
      },
    },
  },
  transform: (value: any) => {
    return Number(currencyMask.unmask(value).replace(',', '.'));
  },
  maskDefault: (value: number) => {
    return currencyMask.mask(value.toFixed(2).replace('.', ','));
  },
});

export const cpfOrCnpjMask = masker({
  masked: {
    mask: [
      {
        mask: '000.000.000-00',
        type: 'CPF',
      },
      {
        mask: '00.000.000/0000-00',
        type: 'CNPJ',
      },
    ],
    dispatch: (appended: any, dynamicMasked: any) => {
      const cpfMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'CPF'
      );

      const cnpjMask = dynamicMasked.compiledMasks.find(
        (prop: any) => prop.type === 'CNPJ'
      );

      if (`${dynamicMasked.value}${appended}`.length > cpfMask.mask.length) {
        return cnpjMask;
      }

      return cpfMask;
    },
  },
});
